module.exports = "https://static.zego.com/_next/static/images/uber-eats-3ac3a6069c2f2c86928b96c706afa46f.svg";